


export default function CardItem({ number, type, status }) {
    return (
        <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl p-5  h-[220px] flex flex-col justify-between">

            {/* Top */}
            <div className="flex justify-between items-center">
                <span className="text-blue-600 font-bold text-lg">{type}</span>
                <span className="text-xl"></span>
            </div>

            {/* Card Number */}
            <div className="text-lg tracking-widest font-semibold">
                XXXX XXXX XXXX {number}
            </div>

            {/* Bottom */}
            <div className="flex justify-between items-center">
                <div>
                    <div className="h-3 w-24 bg-gray-300 rounded mb-2"></div>
                    <div className="h-3 w-16 bg-gray-300 rounded"></div>
                </div>

                {status ? (
                    <span className="material-symbols-outlined text-green-500">
                        check_circle
                    </span>
                ) : (
                    <div className="text-red-400 text-sm">Not Tokenized</div>
                )}
            </div>

        </div>
    );
}

